import { render, staticRenderFns } from "./SmartClassifierAnswer.vue?vue&type=template&id=16c8d095&scoped=true&"
import script from "./SmartClassifierAnswer.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8d095",
  null
  
)

export default component.exports